import { l } from '../lib/imports'

const tumult = require('tumult')

export function create(
  w: number,
  h: number,
  cb: (i: number, j: number, sim: number) => void,
) {
  let simScale = 9 // 16 = blobby, 4 = spaghetti

  const simplex2 = new tumult.Simplex2(l.random(true))

  for (let j = 0; j < h; j++) {
    for (let i = 0; i < w; i++) {
      let dFromCenterX = i - w / 2
      let dFromCenterY = j - h / 2
      let dFromCenter =
        Math.sqrt(dFromCenterX * dFromCenterX + dFromCenterY * dFromCenterY) /
        (h / 2)
      let idFromCenter = dFromCenter
      idFromCenter *= idFromCenter * 1

      let sim = simplex2.gen(i / simScale, j / simScale)
      sim -= idFromCenter * 1.5

      sim += 0.75

      if (sim < -1) {
        sim = -1
      }
      if (sim > 1) {
        sim = 1
      }

      cb(i, j, sim)
      // // let p = (i + j) / (w - 1 + h - 1)
      // let p = (sim + 1) / 2
      // let c = Math.floor(255 * p)

      // let tint = c + c * 256 + c * 256 * 256

      // if (sim > 0) {
      //   p = (sim + 0.5) / 2
      //   c = Math.floor(255 * p)
      //   image.tint = tint
      // }

      // console.log(sim, p, idFromCenter, i, j)
    }
  }
}
